/**
 * 图片和视频的解密的核心代码，主要功能是返回解密后的 base64 数据
 * 
 * 对外默认暴露一个方法
 * 使用案例
 * let res = await static2Base64(url); // base64...
 */

import CryptoJS from "crypto-js";

// ajax获取图片为arraybuffer格式
const urlToBuffer = (url, key, iv) => {
  return new Promise(function(resolve) {
    let xhr = new XMLHttpRequest();
    xhr.open("GET", url, true);
    xhr.responseType = "blob";
    xhr.onload = function() {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          let url = process(xhr.response, key, iv);
          resolve(url);
        } else {
          retry(url, key, iv);
        }
      }
    };
    xhr.send();
  });
};

// 如果获取图片失败,尝试再获取一次 ，图片较少且尺寸较小的话不需要重新获取
const retry = (url, key, iv) => {
  let xhr = new XMLHttpRequest();
  xhr.open("GET", url, true);
  xhr.responseType = "arraybuffer";
  xhr.onload = function() {
    if (xhr.status === 200) {
      process(xhr.response, key, iv);
    }
  };
  xhr.send();
};

const getDAesString = (encrypted, key, iv) => {
  //解密
  key = CryptoJS.enc.Utf8.parse(key);
  iv = CryptoJS.enc.Utf8.parse(iv);
  var decrypted = CryptoJS.AES.decrypt(encrypted, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return decrypted.toString(CryptoJS.enc.Utf8);
};

const getDAes = (data, key, iv) => {
  var decryptedStr = getDAesString(data, key, iv);
  return decryptedStr;
};

const blobToBase64 = (blob) => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.onload = (e) => {
      resolve(e.target.result);
    };
    // readAsDataURL
    fileReader.readAsDataURL(blob);
    fileReader.onerror = () => {
      reject(new Error("blobToBase64 error"));
    };
  });
};

// 将上面下载的图片转为base64编码，并处理key和iv的格式
// 解密方式和后端商定为为CBC模式
const process = async (blob, key, iv) => {
  let base64 = await blobToBase64(blob);

  let base64Prefix = base64.match(/data:.*;base64,/)?.[0];

  if (base64Prefix) {
    let _base64Data = base64.replace(base64Prefix, "");

    // console.log("解密前：" + _base64Data);

    // 解密
    let decryptedStr = getDAes(_base64Data, key, iv);

    // console.log("解密后：" + decryptedStr);

    let url = base64Prefix + decryptedStr;

    return url;
  } else {
    alert("base64 解析异常");
  }
};

export default async (src) => {
  let key = "saIZXc4yMvq0Iz56";
  let iv = "kbJYtBJUECT0oyjo";
  let res = await urlToBuffer(src, key, iv);
  return res;
};
